<template lang="pug">
    #companion-right-arrow-card
      RouterLink(:to="redirectTo")
        .card-title
          span.flex-grow {{ title }} 
          WtSvgIcon( icon="companion/chevron_right" width="24px", height="24px")
  </template>
<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
export default {
  name: "CompanionRightArrowCard",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon
  },
  props: {
    title: { type: String, default: "" },
    redirectTo: { type: String, default: "", required: false }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
#companion-right-arrow-card {
  border-radius: 8px;
  border: 1px solid #d9dbe0;
  background: #fff;

  .card-title {
    color: #1b1d20;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    padding: 8px 4px 8px 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }
}
</style>
